import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../../components';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { useRef } from 'react';
import { request } from '../../../../../../utils';
import { toast } from '../../../../../../utils';

export const DoseMasterDetailsForm = ({ onClose, setDose, setDoseDialogue }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        dose: Yup.string().required(' ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;

  const formSubmit = async (formValues) => {
    const response = await request('/dose-master-create', {
      method: 'POST',
      body: {
        dose: formValues.dose
      }
    });
    if (response?.success) {
      toast(`Successfully ${'created'}Dose master`, { variant: 'success' });
      setDose((prev) => [...prev, { dose: formValues.dose }]);
      setDoseDialogue(false);
    } else {
      toast(`Failed to ${'create'}Dose master`, {
        variant: 'error'
      });
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
        <Grid item>
          <Typography fontWeight="bold" fontSize="14px" color="red">
            Add Dose
          </Typography>
        </Grid>
        <TextField name="dose" />
      </Grid>
      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
